import { useState } from 'react';
import { FormValidation } from '../../../global-types';
import {
  OnEditAddress,
  OnSkipValidation,
  SubmitEditedAddress,
} from '../components/address-confirmation/address-confirmation-types';
import { useAddressValidationText } from '../components/address-confirmation/hooks/use-address-validation-text';

// This hook handles the address validation logic for 1:1, sns, and 1:M (return-only) cards
export const useAddressValidation = ({
  addressesToValidate,
  submitEditedAddress,
  isAddressFromAddressBook = false,
  onSkipValidation,
  onEditAddress,
}: {
  addressesToValidate: FormValidation[];
  onSkipValidation: OnSkipValidation;
  onEditAddress: OnEditAddress;

  // AddressBook props
  submitEditedAddress?: SubmitEditedAddress;
  isAddressFromAddressBook?: boolean;

  // 1:M return-recipient props
  handleEditReturnRecipientAddresses?: OnEditAddress;
  handleConfirm?: () => void;
}) => {
  const [currentAddressStep, setCurrentAddressStep] = useState(1);

  const currentValidationAddress = addressesToValidate[Number(currentAddressStep - 1)];
  const { validationTitle, validationMessageKey } = useAddressValidationText({
    currentValidationAddress,
  });

  // Handles the confirmation button click
  const handleConfirm = () => {
    if (isAddressFromAddressBook && submitEditedAddress) {
      // handles address book validation
      submitEditedAddress(addressesToValidate);
    } else {
      // handles address form validation
      if (addressesToValidate?.length === currentAddressStep) {
        onSkipValidation(addressesToValidate);
      } else {
        setCurrentAddressStep((prevIndex) => prevIndex + 1);
      }
    }
  };

  // Handles the edit address button click
  const handleEditAddress = () => {
    // how to handle 1:M return-recipient card?
    onEditAddress(currentValidationAddress.addressType);
  };

  return {
    validationTitle,
    validationMessageKey,
    addressInfo: currentValidationAddress.address,
    handleConfirm,
    handleEditAddress,
  };
};
